export enum CurrentTab {
  BETTING_INFO = 'BETTING_INFO',
  PREFERENCE = 'PREFERENCE',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
}
